module.exports = __webpack_public_path__ + "img/vedio-trading.cebe1285.gif";